export default __webpack_public_path__ + "static/media/ci_202109.9691a449.png";